import React from "react";
import { Row } from "../_ui";
import LegalRewriterPanel from "./LegalRewriterPanel";
export default function CustomHtmlPanel({ site, form, setField }) {
  return (
    <>
      <Row label="Custom About HTML">
        <div className="space-y-2">
          <textarea
            data-testid="sitedetail-about-html"
            value={form.about_html}
            onChange={(e) => setField("about_html", e.target.value)}
            rows={8}
            placeholder="Leave blank to use the auto-generated unique About copy. Paste your own HTML here to override (supports <h2>, <p>, <a> etc.)."
            className="admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-xs mono leading-relaxed"
            style={{ minHeight: 180, fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}
          />
          <div className="text-[11px] text-zinc-500 mono">
            When empty, <span className="text-zinc-300">/about</span> renders procedurally-varied copy seeded by this site&apos;s ID — every site in the network gets a different paragraph mix to avoid SEO footprint.
            {" "}
            <a
              href={`${process.env.REACT_APP_BACKEND_URL}/api/render/sites/${site.slug}/about`}
              target="_blank"
              rel="noreferrer"
              className="text-amber-400 hover:underline"
            >Preview ↗</a>
          </div>
        </div>
      </Row>

      <div className="pt-6 mt-6 border-t border-zinc-800 label-tiny">Legal pages (Privacy · Terms · CCPA)</div>
      <Row label="AI paraphrase">
        <LegalRewriterPanel site={site} />
      </Row>

      <div className="pt-6 mt-6 border-t border-zinc-800 label-tiny">Custom &lt;head&gt; HTML</div>
      <Row label="Inject script / meta">
        <div className="space-y-2">
          <textarea
            data-testid="sitedetail-custom-head-html"
            value={form.custom_head_html}
            onChange={(e) => setField("custom_head_html", e.target.value)}
            rows={8}
            spellCheck={false}
            placeholder={'<!-- e.g. Facebook Pixel, Hotjar, Plausible, search-console verification, custom <meta> tags, <link rel="preconnect"> etc. -->\n<script async src="https://example.com/tracker.js"></script>'}
            className="admin-input w-full bg-transparent border border-zinc-800 px-3 py-2 rounded-sm text-xs mono leading-relaxed"
            style={{ minHeight: 180, fontFamily: "ui-monospace, SFMono-Regular, Menlo, monospace" }}
          />
          <div className="flex items-center justify-between gap-3 text-[11px] mono">
            <span className="text-amber-400/80">
              ⚠ Injected verbatim into every public page&apos;s &lt;head&gt;. Only paste code from trusted sources — a bad &lt;script&gt; here will run on every visitor.
            </span>
            <span className={`shrink-0 ${(form.custom_head_html || "").length > 45000 ? "text-rose-400" : "text-zinc-500"}`}>
              {(form.custom_head_html || "").length.toLocaleString()} / 50,000
            </span>
          </div>
        </div>
      </Row>
    </>
  );
}
